import {
  getPackageBySlug
} from "./chunk-CIE4FB47.mjs";
import {
  __spreadValues
} from "./chunk-RGHW4PYM.mjs";

// src/hooks/wbk/packages/bySlug.ts
import { useQuery } from "@tanstack/react-query";
var useGetTicketingPackage = (props, options) => {
  return useQuery(__spreadValues({
    queryKey: ["getTicketingPackage ", props],
    queryFn: () => getPackageBySlug(props)
  }, options));
};

export {
  useGetTicketingPackage
};
//# sourceMappingURL=chunk-XLNLAS5B.mjs.map